import React from "react";

export default function TodaysTaskTile({ count, ...props }) {
  return (
    <div
      className="border p-2 d-inline-flex ml15"
      onClick={props.setFilter}
      style={{
        cursor: "pointer",
        marginBottom: "10px",
        marginTop: "10px",
        backgroundColor: `${props.active ? props.active : ""} `,
      }}
    >
      <div>{props.text ? props.text : "My Today's Tasks"}</div>
      <div className="badge">{count}</div>
    </div>
  );
}
